import { render, staticRenderFns } from "./ImageMapView.vue?vue&type=template&id=70ef22ed&scoped=true"
import script from "./ImageMapView.vue?vue&type=script&lang=js"
export * from "./ImageMapView.vue?vue&type=script&lang=js"
import style0 from "./ImageMapView.vue?vue&type=style&index=0&id=70ef22ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ef22ed",
  null
  
)

export default component.exports